// HEAL-46b §9.3 — подпись на экранах ожидания.
//
// Текст зависит от того, дойдёт ли до человека уведомление. Обещать доставку
// туда, куда мы не можем доставить, нельзя: человек закроет приложение и будет
// ждать того, чего не будет.
//
// Два состояния, и разница между ними не косметическая:
//   push дойдёт   → «сообщим, когда всё будет готово» — можно уходить спокойно
//   push не дойдёт → «обработка продолжится» — уйти можно, но придётся вернуться
//                     и посмотреть самому
//
// На вебе всегда второй вариант: push в браузере не делаем (D-9).

import { useEffect, useState } from 'react';
import { currentPushToken, pushPermission, pushSupported } from '@/lib/push';

export function WaitingHint({ className }: { className?: string }) {
  const [willNotify, setWillNotify] = useState(false);

  useEffect(() => {
    let alive = true;

    void (async () => {
      if (!pushSupported()) return;

      // Разрешение выдано И токен у нас есть. Второе условие не лишнее: при
      // отписке в Профиле (D-32) токен стирается, а системное разрешение
      // остаётся — по одному разрешению мы пообещали бы лишнего.
      const [permission, token] = await Promise.all([pushPermission(), currentPushToken()]);

      if (alive) setWillNotify(permission === 'granted' && token !== null);
    })();

    return () => {
      alive = false;
    };
  }, []);

  return (
    <p className={className}>
      {willNotify
        ? 'Можно закрыть приложение — сообщим, когда всё будет готово'
        : 'Можно закрыть приложение — обработка продолжится'}
    </p>
  );
}
